/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {SkeletonSettings} from "../utils/SkeletonSettings";
import ContentLoader from "react-content-loader";

export const ECOMVariationSkeleton = (props) => (
    <ContentLoader
        height={260}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderRadius: "4px"}}
        {...props}>

        {/* Block */}
        <rect x="0" y="0" width="100%" height="100%"/>

    </ContentLoader>
)
